import React, { Component } from "react"
import styled from "styled-components"
import * as Dropzone from "dropzone"
Dropzone.autoDiscover = false

const dropzoneRemoveFileId = "dropzone-remove-file"

const AddImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${({ mask }) => mask.borderRadius}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .dz-message {
    color: ${({ mask }) => mask.textColor};
    font-family: "Open Sans";
    font-size: 20px;
  }
`

class UploadImageBox extends Component {
  state = {
    uploadedComplete: false,
    file: null,
  };

  dropzoneDiv = React.createRef();

  componentDidMount() {
    this.dropzoneInstance = new Dropzone(this.dropzoneDiv.current, {
      url: "/",
      maxFiles: 1,
      maxThumbnailFilesize: 100,
      acceptedFiles: "image/*",
      previewTemplate: this.previewTemplate(),
    })

    this.dropzoneInstance.on("addedfile", file => {
      this.dropzoneInstance.on("thumbnail", thumb => {
        this.setState({ thumb, uploadedComplete: true }, () => {
          const removeFileButton = document.getElementById(
            dropzoneRemoveFileId
          )
          removeFileButton.addEventListener("click", this.removeFile)
          this.props.addUploadedThumbnail(thumb)
        })
      })
    })
  }

  removeFile = () => {
    const { file } = this.state
    this.dropzoneInstance.removeFile(file)
    this.setState({ file: null, uploadedComplete: false }, () => {
      this.props.removeUploadedThumbnail(file.dataURL)
    })
  };

  previewTemplate = () => /* html */ `
    <div class="dz-preview dz-image-preview">
      <div class="dz-image">
        <img data-dz-thumbnail />
      </div>
      <div class="dz-details">
        <div class="dz-filename"><span data-dz-name></span></div>
      </div>
      <button id="${dropzoneRemoveFileId}">Delete</butto>
    </div>
  `;

  render() {
    const { mask, generatingImage } = this.props

    return (
      <AddImage
        ref={this.dropzoneDiv}
        className="upload-box dropzone"
        mask={mask}
      >
        <div className="dz-message" data-dz-message>
          <span className="dz-message-text">
            {generatingImage ? "" : "Click and upload an image"}
          </span>
        </div>
      </AddImage>
    )
  }
}

export default UploadImageBox
